<template>
  <div class="content mt-4">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-8 mt-5">
          <span class="section-title">Demo's</span>
          <div class="block dashboard--block">
            <span class="dashboard--number">{{$globals.inbox.length}}</span>
            <span class="dashboard--block-title">You have <strong>{{$globals.inbox.length}}</strong> new demo's</span>
          </div>
          <div>
            <div class="page-block--title"></div>
          </div>
        </div>
        <div class="col-12 col-md-4 mt-5">
          <span class="section-title">Plans</span>
          <div class="block plan" v-if="plan != null">
            <span class="plan--title">{{plan ? 'Basic' : "Free"}}</span>
            <hr style="border-color: gray;" />
            <p class="plan--description">Your are currently on a <strong>{{plan ? 'Basic' : "Free"}}</strong> plan. </p>

            <p class="plan--description" v-if="plan == true">To cancel your subscription, download your invoices or change creditcard information please navigate to 'billing'.</p>
            <p class="plan--description" v-if="plan == false">To publish your contests and to use all ContestCrate features, upgrade to our 'Basic' plan!
              <br />
              <br />
              <span class="button--checkout" id="stripe"></span>
            </p>

          </div>
          <div>
            <div class="page-block--title"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  export default {
    name: "home",
    components: {},
    data() {
      return {
        plan: null,
        checkoutButton: null,
      };
    },
    methods: {
      setInnerHTML(elm, html) {
        elm.innerHTML = html;
        Array.from(elm.querySelectorAll("script")).forEach(oldScript => {
          const newScript = document.createElement("script");
          Array.from(oldScript.attributes)
            .forEach(attr => newScript.setAttribute(attr.name, attr.value));
          newScript.appendChild(document.createTextNode(oldScript.innerHTML));
          oldScript.parentNode.replaceChild(newScript, oldScript);
        });
      },
      getSubscription() {
        var self = this;
        axios({
            method: "GET",
            crossdomain: true,
            headers: {
              "Content-Type": "Content-Type:application/json"
            },
            url: "/subscription/checkout",
          })
          .then(function(response) {
            console.log(response);
            self.checkoutButton = response.data;
            self.setInnerHTML(document.getElementById('stripe'), response.data);
          })
          .catch(function(error) {
            self.errors = error.response.data;
            self.isLoading = false;
          });
      }
    },
    mounted() {

      var self = this;
      this.isLoading = true;
      axios({
          method: "GET",
          crossdomain: true,
          headers: {
            "Content-Type": "Content-Type:application/json"
          },
          url: "/subscription/status",
        })
        .then(function(response) {
          console.log(response);
          if (!response.data.subscribed) {
            //self.getSubscription();
          }
          self.plan = response.data.subscribed;
        })
        .catch(function(error) {
          self.errors = error.response.data;
          self.isLoading = false;
        });

      this.$globals.getContests();
      this.$globals.getDemos();

      /*if(localStorage.newAccount){
           const introJS = require("intro.js");
           introJS().setOptions({
             steps: [{
               intro: "Welcome in the ContestCrate Dashboard!"
             }, {
               element: document.querySelector('#links'),
               intro: "Here you can navigate through ContestCrate."
             }]
           }).start().oncomplete(function() {
             window.location.href = '/contests?multipage=true';
         }); 
      }*/



    },
  };
</script>